import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {floor} from 'lodash';

export enum TimerState {
    START = 'start',
    PAUSE = 'pause',
    STOP = 'stop'
}

@Component({
    selector: 'app-timer',
    templateUrl: './timer.component.html',
    styleUrls: ['./timer.component.scss']
})
export class TimerComponent implements OnInit, OnDestroy {
    @Input() state = TimerState.STOP;
    @Input() elapsedTime = 0; // ms
    @Input() standardTime = 0; // ms
    @Input() showHeader = false;
    @Input() countdown = false;
    @Input() canPause = true;
    @Input() canStop = true;
    @Input() showControls = true;
    @Input() showStandardTime = true;
    @Input() showWhenStopped = false;
    @Input() preserveElapsedOnStop = false;

    @Output() start = new EventEmitter<any>();
    @Output() pause = new EventEmitter<any>();
    @Output() stop = new EventEmitter<any>();

    elapsedTimeInterval: any;

    constructor() {
    }

    ngOnInit() {
        if (this.state === TimerState.START && !this.elapsedTimeInterval) {
            this.elapsedTimeInterval = setInterval(() => {
                this.elapsedTime += this.countdown ? -1000 : 1000;
            }, 1000);
        }
    }

    onStartTimer() {
        this.start.emit();
    }

    startTimer() {
        this.state = TimerState.START;
        if (!this.elapsedTimeInterval) {
            this.elapsedTimeInterval = setInterval(() => {
                this.elapsedTime += this.countdown ? -1000 : 1000;
            }, 1000);
        }
    }

    onStopTimer() {
        this.stop.emit();
    }

    stopTimer() {
        if (!this.preserveElapsedOnStop) {
            this.elapsedTime = 0;
        }
        this.state = TimerState.STOP;
        clearInterval(this.elapsedTimeInterval);
        this.elapsedTimeInterval = null;
    }

    onPauseTimer() {
        this.pause.emit();
    }

    pauseTimer() {
        this.state = TimerState.PAUSE;
        clearInterval(this.elapsedTimeInterval);
        this.elapsedTimeInterval = null;
    }

    hours(ms: number) {
        const hours = floor(this.abs(ms) / 1000 / 60 / 60);
        return hours < 10 ? `0${hours}` : hours;
    }

    abs(nr: number) {
        return nr < 0 ? -nr : nr;
    }

    ngOnDestroy(): void {
        clearInterval(this.elapsedTimeInterval);
        this.elapsedTimeInterval = null;
    }
}
